import { render, staticRenderFns } from "./MyModule.vue?vue&type=template&id=7ad68d48&scoped=true&"
import script from "./MyModule.vue?vue&type=script&lang=js&"
export * from "./MyModule.vue?vue&type=script&lang=js&"
import style0 from "./MyModule.vue?vue&type=style&index=0&id=7ad68d48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad68d48",
  null
  
)

export default component.exports